import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://dnvxcsifahmplffblwox.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRudnhjc2lmYWhtcGxmZmJsd294Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjczMzM3MTksImV4cCI6MjA4MjkwOTcxOX0.R-Ph9dAUuIJtLKSeLE1L8z9AaGItp30uI-bNYVHPdG0'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})